<template>
  <div>
    <common-table
        :table-columns="tableColumns"
        :url="url"
        :operate="operate"
        :form-fields="formFields"
        :permission="permission"
        :buttons="buttons"
        :searchs="searchs"
        @returnId="returnId"
        ref="table"
    ></common-table>
    <div class="dialog">
      <el-dialog
          title="剪辑"
          :visible.sync="batchVisible"
          custom-class="common-dialog"
          :close-on-click-modal="false"
          @close="resetForm('batchForm')"
          width="30%"
      >
        <div class="dialog_body">
          <el-form
              label-position="right"
              status-icon
              label-width="90px"
              :model="batchForm"
              ref="batchForm"
          >
            <el-form-item
                label="剪辑任务名称"
                prop="clipName"
                :rules="[{ required: true, message: '剪辑任务名称不能为空', trigger: 'blur'}]"
            >
              <el-input
                  v-model="batchForm.clipName"
                  placeholder="请输入剪辑任务名称"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="batchVisible = false">取 消</el-button>
          <el-button type="primary" size="small" @click="submitBatch('batchForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
import request from "@/utils/axios";
import message from "@/utils/message";

export default {
  name: 'DouYinProductRelease',
  components: {CommonTable},
  data() {
    return {
      batchVisible: false,
      batchForm: {
        ids: '',
        clipName:'',
      },
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      },{
        name: 'productName',
        placeholder: '商品名称',
        type: 'input'
      }],
      permission: {
        add: 'douYinProductRelease:add',
        update: 'douYinProductRelease:update',
        delete: 'douYinProductRelease:delete',
        deleteBatch: 'douYinProductRelease:deleteBatch'
      },
      url: {
        get: '/douYinProductRelease/listByCondition',
        add: '/douYinProductRelease/add',
        update: '/douYinProductRelease/update',
        delete: '/douYinProductRelease/delete',
        delete_batch: '/douYinProductRelease/deleteBatch',
        status: '/douYinProductRelease/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      },{
          field: 'productId',  // 字段名
          label: '商品ID',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },
        {
          field: 'productName',
          label: '商品名称',
          show: true,
          width: '',
        }, {
          field: 'douYinVideoAddress',  // 字段名
          label: '抖音视频分享地址',  // 字段显示名称
          sort: false,  // 是否排序
          show: false,  // 是否展示
          detail:true
        },{
          field: 'videoTitle',  // 字段名
          label: '视频标题',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },{
          field: 'url',  // 字段名
          label: '视频url',  // 字段显示名称
          sort: false,  // 是否排序
          show: false,  // 是否展示
          detail:true
        },{
          field: 'thumbnailPath',  // 字段名
          label: '封面',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
          img: true,
        },{
          field: 'salesVolume',  // 字段名
          label: '销量',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },{
          field: 'salesAmount',  // 字段名
          label: '销售额',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },{
          field: 'playCount',  // 字段名
          label: '播放量',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },{
          field: 'numberOfLikes',  // 字段名
          label: '点赞数',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },{
          field: 'numberOfComments',  // 字段名
          label: '评论数',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },{
          field: 'numberOfRetweets',  // 字段名
          label: '转发数',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },{
          field: 'clickThroughRate',  // 字段名
          label: '点击率',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },{
          field: 'orderConversionRate',  // 字段名
          label: '下单转化率',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },{
          field: 'duration',  // 字段名
          label: '时长',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },
        {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }
      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            isEdit: true
          }/*,
          {
							field: 'agentId',  // 字段名
							label: 'agentId',  // 字段显示名称
							type: 'input',
							placeholder: '请输入agentId',
							rules: [
									{ required: true, message: 'agentId不能为空', trigger: 'blur'}
								],
							add: true,
							update: true,
						}*/,{
            field: 'agentId',
            label: '代理：',
            type: 'select',
            placeholder: '请选择代理',
            rules: [{required: true, message: '请选择代理', trigger: 'blur'}],
            selectUrl: '/agent/getAll',
            selectData: [],
            add: true,
            update: true,
            filterable: true,
          }, {
            field: 'productId',  // 字段名
            label: '商品ID',  // 字段显示名称
            type: 'input',
            placeholder: '请输入productId',
            rules: [
              {required: true, message: 'productId不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'douYinVideoAddress',  // 字段名
            label: '视频地址',  // 字段显示名称
            type: 'input',
            placeholder: '请输入DouYinVideoAddress',
            rules: [
              {required: true, message: 'DouYinVideoAddress不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'videoTitle',  // 字段名
            label: '视频标题',  // 字段显示名称
            type: 'input',
            placeholder: '请输入视频标题',
            rules: [
              {required: false, message: '视频标题不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },{
            field: 'url',  // 字段名
            label: '视频url',  // 字段显示名称
            type: 'input',
            placeholder: '请输入视频url',
            rules: [
              {required: true, message: '视频url不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'thumbnailPath',  // 字段名
            label: '视频封面',  // 字段显示名称
            type: 'input',
            placeholder: '请输入视频封面',
            rules: [
              {required: false, message: '视频封面不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'salesVolume',  // 字段名
            label: '销量',  // 字段显示名称
            type: 'input',
            placeholder: '请输入销量',
            rules: [
              {required: false, message: '销量不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'salesAmount',  // 字段名
            label: '销售额',  // 字段显示名称
            type: 'input',
            placeholder: '请输入销售额',
            rules: [
              {required: false, message: '销售额不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'playCount',  // 字段名
            label: '播放量',  // 字段显示名称
            type: 'input',
            placeholder: '请输入播放量',
            rules: [
              {required: false, message: '播放量不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'numberOfLikes',  // 字段名
            label: '点赞数',  // 字段显示名称
            type: 'input',
            placeholder: '请输入点赞数',
            rules: [
              {required: false, message: '点赞数不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'numberOfComments',  // 字段名
            label: '评论数',  // 字段显示名称
            type: 'input',
            placeholder: '请输入评论数',
            rules: [
              {required: false, message: '评论数不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'numberOfRetweets',  // 字段名
            label: '转发数',  // 字段显示名称
            type: 'input',
            placeholder: '请输入转发数',
            rules: [
              {required: false, message: '转发数不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'clickThroughRate',  // 字段名
            label: '点击率',  // 字段显示名称
            type: 'input',
            placeholder: '请输入点击率',
            rules: [
              {required: false, message: '点击率不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'orderConversionRate',  // 字段名
            label: '下单转化率',  // 字段显示名称
            type: 'input',
            placeholder: '请输入下单转化率',
            rules: [
              {required: false, message: '下单转化率不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }
        ]
      },
      operate: [
        {
          icon: 'el-icon-video-play',
          type: 'text',
          text: '播放',
          exist: () => {
            return true;
          },
          handle: (row) => {
            window.open(row.url, '_blank'); // 在新标签页中打开 URL
          }
        },
        {
          icon: 'el-icon-document-copy',
          type: 'text',
          text: '复制链接',
          exist: () => {
            return true;
          },
          handle: (row) => {
            const url = row.url;
            const input = document.createElement('input');
            input.value = url;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);

            message.success("链接已复制到剪贴板");
          }
        }
      ],
      buttons: [{
        icon: 'el-icon-circle-check',
        type: 'success',
        text: '去剪辑',
        permission: 'cuttingTask:update',
        click: () => {
          console.log(this.selectIds)
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要发布的数据')
            return
          }
          this.batchForm.ids = this.selectIds.join(",")
          this.batchVisible = true
        }
      }],
    }
  },
  methods: {
    returnId(data) {
      this.selectIds = data;
      console.log(this.selectIds)
    },
    //重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitBatch(formName) {
      console.log(this.batchForm,"123123")
      this.$refs[formName].validate((valid) => {
        if (valid) {
          request.post({
            url: '/cuttingTask/batchCutting/1' ,
            data: this.batchForm,
            confirm: '确定批量加入剪辑任务？',
            success: (res) => {
              if (res.code === 0) {
                message.success("剪辑任务加入成功");
                this.batchVisible = false;
                this.$refs.table.getData()
              } else {
                message.error(res.msg);
              }
            }
          })
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
